$ = window.jQuery;

// cycle the images in the hero
export default obj => {
	const len = obj.length;
	if (len) {
		let timeout;
		obj
			.on("change", function () {
				clearTimeout(timeout);
				timeout = setTimeout(() => {
					const i = obj.index(this);
					obj.eq(i === len -1 ? 0 : i + 1).prop("checked", true).trigger("change");
				}, 7000);
			})
			.eq(0)
			.trigger("change");
	}
};
